import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const CheckboxInput = props => {
  const {
    field: { touched, error, ...field },
    disabled,
  } = props;

  delete field.initialValue;
  delete field.autofill;
  delete field.onUpdate;
  delete field.valid;
  delete field.invalid;
  delete field.dirty;
  delete field.pristine;
  delete field.active;
  delete field.visited;
  delete field.autofilled;

  const formGroupClass = classnames("form-group", {
    "has-error": touched && error,
  });
  return (
    <div className={formGroupClass}>
      <div className="col-12">
        <label className="control control--checkbox">
          <input
            type="checkbox"
            {...field}
            checked={field.value}
            disabled={disabled}
          />
          <div className="control__indicator" />
        </label>
        {touched && error && <div className="help-block">{error}</div>}
      </div>
    </div>
  );
};

CheckboxInput.propTypes = {
  disabled: PropTypes.bool.isRequired,
  field: PropTypes.object.isRequired,
};

export default CheckboxInput;



// WEBPACK FOOTER //
// ./src/components/CheckboxInput.js